var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function createSportBoostCalculator(featuredSports) {
    const boostMultiplier = 1e5;
    return (sport) => {
        const featuredSportIndex = featuredSports.indexOf(sport.id);
        return boostMultiplier * (featuredSportIndex === -1 ? Infinity : featuredSportIndex);
    };
}
function createSportSortComparator(featuredSports) {
    const calculateSportBoost = createSportBoostCalculator(featuredSports);
    return (sport1, sport2) => {
        // Compute featured sports priority
        const sportBoost1 = calculateSportBoost(sport1);
        const sportBoost2 = calculateSportBoost(sport2);
        // Handle situation when one of the sports is featured
        if (sportBoost1 !== sportBoost2) {
            return sportBoost1 - sportBoost2;
        }
        return sport1.name > sport2.name ? 1 : -1;
    };
}
export function getSports(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { urlService } = options;
        // Load sports
        const fetchOptions = { signal: options.signal };
        const sports = yield fetch(urlService.searchSportsUrl, fetchOptions)
            .then((res) => res.json())
            .then(({ data }) => data)
            .catch(() => []);
        // Sort sports and return them
        sports.sort(createSportSortComparator(options.featuredSports || []));
        return sports;
    });
}
//# sourceMappingURL=getSports.js.map